<div class="flex flex-column gap-xl full-width" *ngIf="formGroup">
    <h1 class="m-0 text-center">Terms & Conditions</h1>

    <div *ngIf="content" [innerHTML]="content"></div>
    <ng-container *ngIf="!content">
        <p class="p1 lvl-2 m-0">
            By checking this box, I consent to the collection, use and disclosure of my personal information as described
            in this paragraph. I agree that the personal information provided above may be used and disclosed by
            {{workflow?.store_name || 'the dealer'}} and/or its agents or service providers (collectively, the 'Dealer') as necessary to obtain credit,
            financial and related personal information (including a credit or consumer information report) about me from
            any credit bureau or credit reporting agency, and to advise me on credit availability in connection with product
            and/or service purchase financing.
        </p>

        <div class="flex flex-column gap-sm full-width">
            <h2 class="m-0">Personal Information</h2>

            <p class="p1 lvl-2 m-0">
                I further agree that the personal information provided above may be disclosed
                to the provider of Dealer's website hosting or related services for the purpose of enabling Dealer to access my
                personal information for marketing purposes. Personal information I provide and credit information obtained may
                also be retained by Dealer and used to facilitate the application process should I subsequently choose to apply
                for credit through Dealer.
            </p>
        </div>
    </ng-container>

    <form [formGroup]="formGroup">
        <app-checkbox formControlName="terms">
            <span *ngIf="checkboxText">{{ checkboxText }}</span>
            <span *ngIf="!checkboxText">Accept terms & conditions</span>
        </app-checkbox>
    </form>
</div>
